/* ============================================================================
 * Louloungerie — US size display (geo-based) + "Your size" line-item property
 * ----------------------------------------------------------------------------
 * NL/BE-bezoekers zien de EU-maten zoals ze in Shopify staan (70A–90E).
 * Alle andere bezoekers zien de US-equivalenten (32A–40DD).
 *
 * Twee lagen:
 *  1. WEERGAVE: zichtbare tekst in maatkiezer, cart drawer, cart-pagina en
 *     sticky bar wordt vervangen (TreeWalker + MutationObserver). De
 *     onderliggende varianten (en dus de Firmhouse-slug-afleiding voor NL/BE)
 *     blijven ongewijzigd.
 *  2. CHECKOUT: de Shopify-checkout kan niet gescript worden en toont altijd
 *     de variant-titel ("70A / S"). Daarom sturen we voor niet-EU-bezoekers
 *     bij het toevoegen aan de cart een line-item property mee
 *     ("Your size": "US 32A / S"). Die staat in cart, checkout, orderbevestiging
 *     en in de Shopify-order. Zonder underscore-prefix, dus zichtbaar.
 *
 * Banden:  EU 70=US 32, 75=34, 80=36, 85=38, 90=40
 * Cups:    A–D gelijk, EU E = US DD
 * String-maten (S/M/L/XL) zijn universeel en blijven staan.
 *
 * Extra: <html> krijgt class "ll-us" voor niet-EU-bezoekers, zodat Liquid-
 * blokken geo-specifieke copy kunnen tonen (.ll-only-us / .ll-only-eu).
 * ========================================================================== */

(function () {
  "use strict";

  // Landen die de EU-weergave houden; alle andere landen krijgen US-maten.
  var EU_DISPLAY_COUNTRIES = ["NL", "BE"];
  var PROPERTY_KEY = "Your size";

  var BAND_MAP = { "70": "32", "75": "34", "80": "36", "85": "38", "90": "40" };

  // "70A" -> "32A", "80E" -> "36DD". Alles wat niet exact matcht blijft staan.
  var SIZE_RE = /\b(70|75|80|85|90)([A-E])\b/g;

  function toUS(text) {
    return text.replace(SIZE_RE, function (m, band, cup) {
      return BAND_MAP[band] + (cup === "E" ? "DD" : cup);
    });
  }

  function hasEUSize(text) {
    SIZE_RE.lastIndex = 0;
    var r = SIZE_RE.test(text || "");
    SIZE_RE.lastIndex = 0;
    return r;
  }

  // Zelfde detectie + sessionStorage-cache als firmhouse-redirect.js.
  function getVisitorCountry() {
    try {
      var cached = sessionStorage.getItem("ll_geo_country");
      if (cached) return Promise.resolve(cached);
    } catch (err) {}
    return fetch("/browsing_context_suggestions.json", { headers: { Accept: "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var c = (d && d.detected_values && d.detected_values.country && d.detected_values.country.handle) || "";
        try { if (c) sessionStorage.setItem("ll_geo_country", c); } catch (err) {}
        return c;
      })
      .catch(function () { return ""; });
  }

  /* ---------------------------------------------------------------------
   * 1. Weergavelaag
   * ------------------------------------------------------------------- */
  var SCOPES = [
    ".hdt-product__variant-picker",
    ".hdt-mini-cart",
    "#shopify-section-cart-drawer",
    ".hdt-main-cart",
    ".hdt-page-cart",
    ".hdt-cart-page__items",
    ".hdt-cart-items",
    ".hdt-sticky-btn-atc"
  ].join(", ");

  function convertIn(root) {
    var containers = root.matches && root.matches(SCOPES) ? [root] : root.querySelectorAll(SCOPES);
    for (var i = 0; i < containers.length; i++) {
      var walker = document.createTreeWalker(containers[i], NodeFilter.SHOW_TEXT, null);
      var node;
      while ((node = walker.nextNode())) {
        // De property-regel ("Your size: US 32A / S") bevat al US-maten; overslaan.
        if (node.parentElement && node.parentElement.closest(".hdt-product-details__item--property")) continue;
        if (hasEUSize(node.nodeValue)) node.nodeValue = toUS(node.nodeValue);
      }
      // <option>-teksten in de sticky-bar-select
      var opts = containers[i].querySelectorAll("option");
      for (var o = 0; o < opts.length; o++) {
        if (hasEUSize(opts[o].textContent)) opts[o].textContent = toUS(opts[o].textContent);
      }
    }
  }

  function startDisplay() {
    convertIn(document.body);
    // Thema en cart drawer renderen stukken DOM opnieuw (variant-wissel,
    // toevoegen aan cart). Idempotent: US-maten matchen het EU-patroon niet.
    var scheduled = false;
    new MutationObserver(function () {
      if (scheduled) return;
      scheduled = true;
      setTimeout(function () {
        scheduled = false;
        convertIn(document.body);
      }, 60);
    }).observe(document.body, { childList: true, subtree: true, characterData: true });
  }

  /* ---------------------------------------------------------------------
   * 2. Line-item property "Your size" bij add-to-cart
   * ------------------------------------------------------------------- */
  var variantTitles = {}; // variant id -> "70A / S"

  function cacheProduct(handle) {
    if (!handle) return Promise.resolve();
    return fetch("/products/" + handle + ".js", { headers: { Accept: "application/json" } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        if (!p || !p.variants) return;
        for (var i = 0; i < p.variants.length; i++) variantTitles[String(p.variants[i].id)] = p.variants[i].title;
      })
      .catch(function () {});
  }

  function propertyValue(variantTitle) {
    return hasEUSize(variantTitle) ? "US " + toUS(variantTitle) : "";
  }

  function isCartAdd(url) {
    return typeof url === "string" && /\/cart\/add(\.js)?(\?|$)/.test(url.split("#")[0]);
  }

  // Vooraf: property toevoegen aan de request-body als we de variant kennen.
  function enrichBody(init) {
    if (!init || !init.body) return false;
    var body = init.body;
    if (typeof FormData !== "undefined" && body instanceof FormData) {
      var id = body.get("id");
      var val = propertyValue(variantTitles[String(id)] || "");
      if (!val || body.has("properties[" + PROPERTY_KEY + "]")) return false;
      body.append("properties[" + PROPERTY_KEY + "]", val);
      return true;
    }
    if (typeof body === "string") {
      var trimmed = body.trim();
      if (trimmed.charAt(0) === "{") {
        try {
          var json = JSON.parse(trimmed);
          var changed = false;
          var items = json.items || (json.id ? [json] : []);
          for (var i = 0; i < items.length; i++) {
            var v = propertyValue(variantTitles[String(items[i].id)] || "");
            if (!v) continue;
            items[i].properties = items[i].properties || {};
            if (!items[i].properties[PROPERTY_KEY]) { items[i].properties[PROPERTY_KEY] = v; changed = true; }
          }
          if (changed) init.body = JSON.stringify(json);
          return changed;
        } catch (err) { return false; }
      }
      if (/(^|&)id=/.test(trimmed) && trimmed.indexOf("properties%5B" + encodeURIComponent(PROPERTY_KEY) + "%5D") === -1) {
        var m = trimmed.match(/(?:^|&)id=(\d+)/);
        var val2 = m ? propertyValue(variantTitles[m[1]] || "") : "";
        if (!val2) return false;
        init.body = trimmed + "&properties%5B" + encodeURIComponent(PROPERTY_KEY) + "%5D=" + encodeURIComponent(val2);
        return true;
      }
    }
    return false;
  }

  // Achteraf (fallback, bv. quick-add van een ander product): property via change.js zetten.
  function backfill(responseClone) {
    responseClone.json().then(function (data) {
      var items = data && data.items ? data.items : (data && data.key ? [data] : []);
      items.forEach(function (item) {
        if (!item || !item.key) return;
        if (item.properties && item.properties[PROPERTY_KEY]) return;
        var val = propertyValue(item.variant_title || "");
        if (!val) return;
        var props = Object.assign({}, item.properties || {});
        props[PROPERTY_KEY] = val;
        fetch("/cart/change.js", {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({ id: item.key, quantity: item.quantity, properties: props })
        }).then(function () {
          document.dispatchEvent(new CustomEvent("ll:cart-property-updated"));
        }).catch(function () {});
      });
    }).catch(function () {});
  }

  function installFetchHook() {
    if (!window.fetch || window.fetch.__llSizes) return;
    var origFetch = window.fetch;
    var hooked = function (input, init) {
      var url = typeof input === "string" ? input : (input && input.url) || "";
      if (!isCartAdd(url)) return origFetch.apply(this, arguments);
      init = init || {};
      var enriched = false;
      try { enriched = enrichBody(init); } catch (err) {}
      return origFetch.call(this, input, init).then(function (res) {
        if (!enriched && res && res.ok) { try { backfill(res.clone()); } catch (err) {} }
        return res;
      });
    };
    hooked.__llSizes = true;
    window.fetch = hooked;
  }

  // Klassieke (non-AJAX) formulier-submits naar /cart/add: hidden input toevoegen.
  function installFormHook() {
    document.addEventListener("submit", function (e) {
      var form = e.target;
      if (!form || !form.action || !isCartAdd(form.action)) return;
      var idInput = form.querySelector('[name="id"]');
      var val = idInput ? propertyValue(variantTitles[String(idInput.value)] || "") : "";
      if (!val || form.querySelector('[name="properties[' + PROPERTY_KEY + ']"]')) return;
      var hidden = document.createElement("input");
      hidden.type = "hidden";
      hidden.name = "properties[" + PROPERTY_KEY + "]";
      hidden.value = val;
      form.appendChild(hidden);
    }, true);
  }

  function startProperty() {
    installFetchHook();
    installFormHook();
    var m = location.pathname.match(/\/products\/([^\/?#]+)/);
    cacheProduct(m ? m[1] : "");
  }

  /* ---------------------------------------------------------------------
   * Boot
   * ------------------------------------------------------------------- */
  getVisitorCountry().then(function (country) {
    if (!country || EU_DISPLAY_COUNTRIES.indexOf(country) !== -1) return; // EU-weergave houden
    document.documentElement.classList.add("ll-us");
    startProperty();
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", startDisplay);
    } else {
      startDisplay();
    }
  });
})();
